export const WEBSITE_MESSAGE = 'Enter a website address, like www.example.co.nz';

/** Letters only, and at least two of them: the last label of a real host name. */
const TOP_LEVEL_DOMAIN = /^[a-z]{2,}$/i;

/**
 * Whether a website address is plausible. An empty value is not a website; callers decide if it is
 * required.
 *
 * The scheme is optional, since people write "www.example.co.nz" far more often than a full URL.
 * What this catches is text that is not an address at all: a sentence, a name, or a host with no
 * domain ending.
 */
export const isValidWebsite = (website: string): boolean => {
	const trimmed = website.trim();
	if (!trimmed || /\s/.test(trimmed)) return false;

	const withScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
	let url: URL;
	try {
		url = new URL(withScheme);
	} catch {
		return false;
	}
	if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;

	const labels = url.hostname.split('.');
	return labels.length >= 2 && labels.every(Boolean) && TOP_LEVEL_DOMAIN.test(labels[labels.length - 1]);
};
